import { render, staticRenderFns } from "./entityConfig.vue?vue&type=template&id=5faadd8c&scoped=true"
import script from "./entityConfig.vue?vue&type=script&lang=js"
export * from "./entityConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faadd8c",
  null
  
)

export default component.exports